import { getAuthModule } from '@littlebird/auth-client';

import { getEnvVar } from '@/env';

import { BrowserCallbackAdapter } from './callback-adapter';
import { GOOGLE_INTEGRATION_PROVIDER } from './providers';
import { initiateSocialLogin } from './social-login';

import type {
  GoogleSignupConsentConfig,
  GoogleSignupToolkit,
} from './google-signup-consent-config';

/** Request extra Google permissions without replacing the current Littlebird session */
export async function connectGoogleSignupIntegrations(
  consentConfig: GoogleSignupConsentConfig,
  loginHint: string
): Promise<GoogleSignupToolkit[]> {
  const tokens = await initiateSocialLogin(
    GOOGLE_INTEGRATION_PROVIDER,
    {
      domain: getEnvVar('VITE_AUTH0_DOMAIN'),
      clientId: getEnvVar('VITE_AUTH0_CLIENT_ID'),
      audience: getEnvVar('VITE_AUTH0_AUDIENCE'),
    },
    new BrowserCallbackAdapter(),
    {
      loginHint,
      connectionScopes: ['openid', 'email', 'profile', ...consentConfig.scopes],
    }
  );
  const accessToken = await getAuthModule().tokenManager.getAccessToken();
  const response = await fetch(
    `${getEnvVar('VITE_API_URL')}/google-signup/connect`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        consent_access_token: tokens.access_token,
        toolkits: consentConfig.toolkits,
      }),
    }
  );
  if (!response.ok) {
    const body = (await response.json()) as { detail?: string };
    throw new Error(
      typeof body.detail === 'string'
        ? body.detail
        : 'Could not connect Google integrations. Please try again.'
    );
  }
  const result = (await response.json()) as {
    connected_toolkits: GoogleSignupToolkit[];
  };
  return result.connected_toolkits;
}
